import React from 'react';
import { connect } from 'react-redux';
import RecentlyViewed from '../desktop/product/components/RecentlyViewed';
import ProductQuickview from './ListingPage/quickview/ProductQuickview';
import Loader from './Loader';
import { getDecodedString } from '../../modules/ajio-util/stringDecoder';


import screen from '../../refresh/constants/pageType.constant';
import luxeScreens from '../../refresh/constants/luxeScreenType';
import { gtmPagePush, gtmEventPush, getStoreName } from '../../modules/ga/GTMdatalayer';
import { signInCheck } from './CheckUserStatus';
import properties from '../../modules/ajio-util/properties';
import { FLEEK_STORE } from '../../constants/constant';


const imageBaseUrl = properties.getProperty('imageBaseUrl');
const parentUrl = properties.getProperty('parentUrl');
const luxeURL = properties.getProperty('luxeURL');
class NoSearchResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    liveMessage: ""
  };
  }
    
  componentDidMount() {
    const { search: { pageType = '', zeroSearchPageName = '', pageName = '' } = {} } = screen;
    const {
      metaData: { name = '' },
      text,
      isSuggestStoreLink,
      redirectionStore
    } = this.props;
    const storeName = getStoreName();
    if (isSuggestStoreLink) {
      const eventObj = {
        event: 'zero_search_interactions',
        search_term: text,
        event_category: 'zero search interactions',
        event_action: 'redirection widget impression',
        event_label: redirectionStore,
        page_type: 'SLP screen',
        page_name: `/SLP Screen/(ZSR)/${text}/${storeName}`
      };
      gtmEventPush(eventObj);
    }

    gtmPagePush(zeroSearchPageName, pageType, window.__ENV__ || '', {
      store: storeName,
      zero_search_term: text
    },{
      search_term: text
    });

    setTimeout(() => {
      this.setState({
        liveMessage: `Sorry! We couldn't find any matching items for ${this.props.text}. Don't give up - check the spelling, or try less specific search terms`
      });
    }, 300);
  }

  componentDidUpdate(prevProps) {
  if (prevProps.text !== this.props.text) {
    setTimeout(() => {
      this.setState({
        liveMessage: `Sorry! We couldn't find any matching items for ${this.props.text}. Don't give up - check the spelling, or try less specific search terms`
      });
    }, 300);
  }
}

  eventPush = ({ eventName, ...rest }) => {
    const { plp: { screenType = '', screenName = '' } = {} } = luxeScreens;
    const {
      metaData: { name: storeName = '' }
    } = this.props;
    let eventPushObj = {
      user_details: {
        store_type: storeName,
        user_status: signInCheck() ? 'logged in' : 'not logged In',
        time_of_the_day: '',
        login_type: signInCheck() ? 'logged in' : 'not logged In',
        screen_name: screenName,
        screen_type: screenType
      }
    };
    gtmEventPush({
      event: eventName,
      ...rest,
      ...eventPushObj.user_details
    });
  };

  redirectToAlternateStore = () => {
    const {
      metaData: { name = '' },
      newDesignLuxe,
      storeRedirectURL,
      text,
      redirectionStore
    } = this.props;
    const { pathname = '', search = '' } = window.location;
    const storeName = getStoreName();
    const eventObj = {
      event: 'zero_search_interactions',
      search_term: text,
      event_category: 'zero search interactions',
      event_action: 'redirection widget click',
      event_label: redirectionStore,
      page_type: 'SLP screen',
      page_name: `/SLP Screen/(ZSR)/${text}/${storeName}`
    };
    gtmEventPush(eventObj);
    window.open(storeRedirectURL, '_blank');
  };

  render() {
    let {
      freeTextSearch = '',
      productIds = [],
      metaData: { sis = false, name = '' } = {},
      text = '',
      isSuggestStoreLink = false,
      newDesignLuxe,
      redirectionStore
    } = this.props;
    text = getDecodedString(text) || '';
    let recentViewedProductIds = [];
    console.log('---test console---', productIds);
    if (productIds?.length > 0) {
      recentViewedProductIds = productIds.map(element => element.id);
    }
    return (
      <>
        {isSuggestStoreLink ? (
          <div className={`suggestion-link-wrapper ${newDesignLuxe ? 'luxe' : ''}`}>
            <div className="suggestion-link-container">
              <div className={'box'}>
                <div className={'no-search-found-message'}>
                  <p className={'title'}>{`'${text}'`}</p>
                  <p className={'sub-title'}>
                    {redirectionStore === FLEEK_STORE
                      ? 'is available on AJIOGRAM - fashionverse of hottest styles and dope brands'
                      : redirectionStore === 'street'
                      ? 'is available on AJIO Street - affordable fashion for everyone'
                      : redirectionStore === 'luxe'
                      ? 'is available on AJIO LUXE - home to premium luxury brands'
                      : 'is available on AJIO - the one stop affordable fashion destination'}
                  </p>
                </div>
                <div className="link-box">
                  <div
                    className="link-button-desktop"
                    onClick={() => {
                      this.redirectToAlternateStore();
                    }}
                  >
                    <p className="search-label">View Results in</p>
                    <img
                      className={`store-logo ${redirectionStore === 'street' ? 'street-logo' : ''}`}
                      src={`${imageBaseUrl}/static/img/${
                        redirectionStore === FLEEK_STORE
                          ? 'ajiogram-logo-black.png'
                          : redirectionStore === 'street'
                          ? 'ajio-street-logo.png'
                          : redirectionStore === 'luxe'
                          ? 'ajioluxe-logo.svg'
                          : 'Ajio-Logo.svg'
                      }`}
                      alt={
                        redirectionStore === FLEEK_STORE
                          ? 'Ajiogram logo'
                          : redirectionStore === 'street'
                          ? 'Ajio street logo'
                          : redirectionStore === 'luxe'
                          ? 'Luxe logo'
                          : 'Ajio logo'
                      }
                    />
                    <img
                      className="right-arrow"
                      src={`${imageBaseUrl}/static/img/suggestion-right-back${
                        redirectionStore === 'luxe' ? '-luxe' : ''
                      }.svg`}
                      alt="Right arrow"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="no-results-with-search">
         
            <div className="no-search-result-page">
              <Loader name="quick-view-loader" />
              <div className="no-search-result-container">
                <div className="no-search-result">
                  <div className="fnl-slpsearch-firstLine">
                    Sorry! We couldn't find any matching items for
                  </div>
                  <div className="fnl-slpsearch-SecondLine">{text}</div>
                  <div className="fnl-plpsearch-wborder2" />
                  <div className="search-spellcheck-message">
                    Don't give up - check the spelling, or try less specific search terms
                  </div>
                </div>
                {/* Hidden live region that triggers announcement */}
                <div aria-live="polite" role="status" className="sr-only">
                  {this.state.liveMessage}
                </div>
              </div>
              {productIds.length > 0 && (
                <RecentlyViewed
                  productIds={recentViewedProductIds}
                  luxeEventPush={this.eventPush}
                />
              )}
              <ProductQuickview />
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { productsAdditionalInfo = {}, recentlyViewed = {}, metaData, request } = state;
  const { query = {} } = request;
  const { text } = query;
  const {
    freeTextSearch = '',
    redirectionStore = '',
    storeRedirectURL = ''
  } = productsAdditionalInfo;
  const { recent: productIds = [] } = recentlyViewed;
  return {
    storeRedirectURL,
    redirectionStore,
    freeTextSearch,
    productIds,
    metaData,
    text,
    ...ownProps
  };
};

export default NoSearchResult = connect(mapStateToProps)(NoSearchResult);
